import React, { useState } from "react";
import { starIcon, cartIcon } from "../utils/Icons";

export default function Card({ data }) {
  const { title, img, star, prevPrice, newPrice, company, color } = data;
  const [stars, setStars] = useState([
    "starIcon",
    "starIcon",
    "starIcon",
    "starIcon",
    "starIcon",
  ]);

  return (
    <>
      <div className="product-box">
        <img src={img} alt={title} />
        <h2>{title}</h2>
        <p>
          {stars.slice(0, star).map((str, i) => (
            <span className="rating" key={i}>
              {starIcon}
            </span>
          ))}
          <span className="brand">{company}</span>
        </p>
        <p>
          <span className="actual-price">${prevPrice}</span> {newPrice}
        </p>
        <p>
          <span className="brand-color" style={{ background: color }}></span>
          <span className="add-cart">{cartIcon}</span>
        </p>
      </div>
    </>
  );
}
